var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #121628;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70,140C31.53,140,0,108.47,0,70S31.53,0,70,0s70,31.53,70,70-31.53,70-70,70ZM70,3.78C33.42,3.78,4.41,33.42,4.41,69.37s29.64,65.59,65.59,65.59,65.59-29.64,65.59-65.59S105.95,3.78,70,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.95,57.05v-20.79h-25.9v20.79h-20.79v25.9h20.79v20.79h25.9v-20.79h20.79v-25.9h-20.79ZM59.05,59.05v-20.79h21.9v20.79h20.79v10.45h-28.36l-4.21,13.93-4.02-25.87-4.62,11.94h-22.27v-10.45h20.79ZM80.95,80.95v20.79h-21.9v-20.79h-20.79v-10.45h22.95l3.52-9.1,4.12,26.53,5.26-17.43h27.62v10.45h-20.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacie);
export default __webpack_public_path__ + "static/media/pharmacie.48a7b66da077e953001280b9448b5710.svg";
export { ForwardRef as ReactComponent };